import { NewChapterPage } from "./NewChapterPage";
export default NewChapterPage;
